// @ts-nocheck
import Button from "atoms/button/button";
import * as dynamicGridSelectors from "models/dynamicGrid/selector";
import Stack from "molecules/stack/stack";
import StackItem from "molecules/stackItem/stackItem";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as constants from "./constants";
import ThetaGridPaginated from "templates/thetaGridPaginated";
import * as dynamicGridQuery from "models/dynamicGrid/query";
import * as generateOrderSelectors from "./selectors";
import _ from "lodash";
import SheetBody from "atoms/sheet/sheetBody/sheetBody";
import Sheet from "atoms/sheet/sheet";
import { REQUESTS } from "utils/services/thetaretail/requests";
import { Typography } from "antd";
import { useColumnAliasName } from "hooks/useColumnAliasName";
import { fetchBookmarksList } from "models/bookmarks/sagaActions";

type TProps = {
  hideModal: React.MouseEventHandler;
  handleNextClick: React.MouseEventHandler;
  goBack: React.MouseEventHandler;
};

const { Title } = Typography;

const tableId = constants.MODAL_TABLE_IDS.INVENTORY;

const ReserveInventory = (props: TProps) => {
  const { hideModal, handleNextClick, goBack } = props;

  const dispatch = useDispatch();

  const getColumnAliasName = useColumnAliasName(constants.UPLOAD_MODEL_ID);

  const data = useSelector((state) => generateOrderSelectors.getData(state));

  const selectedReserveInventory = useSelector((state) =>
    dynamicGridSelectors.getTableSelection(
      state,
      constants.MODAL_TABLE_IDS.INVENTORY
    )
  );

  const selectedStores = useSelector((state) =>
    dynamicGridSelectors.getTableSelection(
      state,
      constants.MODAL_TABLE_IDS.STORES
    )
  );

  const storeSearch = useSelector((state) =>
    dynamicGridSelectors.getGridFilters(
      state,
      constants.MODAL_TABLE_IDS.INVENTORY
    )
  );

  const isLoadingGrid = useSelector((state) =>
    dynamicGridSelectors.isLoading(state, constants.MODAL_TABLE_IDS.INVENTORY)
  );
  const hasGridData = useSelector(
    (state) =>
      dynamicGridSelectors.getGridData(
        state,
        constants.MODAL_TABLE_IDS.INVENTORY
      )?.length
  );

  const validateFormData = React.useCallback(() => {
    let hasError = true;

    if (
      selectedReserveInventory?.isSelectAll ||
      selectedReserveInventory?.selectedRowKeys?.length
    ) {
      hasError = false;
    }

    return hasError;
  }, [selectedReserveInventory]);
  const [ref, handleUpdateRef] = useState(null);

  const gridConfig = {
    enableSelection: true,
    enableSorting: true,
    selectionCallBack: () => {},
  };
  let parsedStoreSearch;

  if (selectedReserveInventory?.isSelectAll) {
    parsedStoreSearch = {
      filter: dynamicGridQuery.createFiltersFromQueries(
        storeSearch ? storeSearch.search : []
      ),
    };
  }
  const customerOptions = useSelector((state) =>
    generateOrderSelectors.getCustomerOptions(state)
  );

  React.useEffect(() => {
    dispatch(fetchBookmarksList({ tableId }));
  }, [dispatch]);

  let templateConfig = {
    gridConfig,
    isFilterEnabled: true,
    tableId,

    dataProviderOptions: {
      version: 2,
      type: "POST",
      queryParams: {},
      ...REQUESTS.POST.GET_GRID_DETAILS_V2,
      pathParams: { tableId },
      multiSelectFieldGroups: {
        CustomerID: data.customerID.includes("-1")
          ? customerOptions.map(({ value }) => value).join(",")
          : data.customerID,
        StoreScheduleID: data.useStoreSchedule
          ? data?.storeScheduleID
          : undefined,
        StartShipDate: data.shipStartDate,
        EndShipDate: data.shipToDate,
      },
      multiSelectFilterFieldGroups: {
        StoreSearch: selectedReserveInventory?.isSelectAll
          ? (storeSearch?.search ?? [])
          : [],
        UsePlanogram: data.usePlanogram,
      },

      body: {
        fieldGroups: {
          CustomerID: data.customerID.includes("-1")
            ? customerOptions.map(({ value }) => value).join(",")
            : data.customerID,
          StoreScheduleID: data.useStoreSchedule
            ? data?.storeScheduleID
            : undefined,
          StartShipDate: data.shipStartDate,
          EndShipDate: data.shipToDate,
          UsePlanogram: data.usePlanogram,
        },
        filterGroups: {
          StoreSearch: selectedStores?.isSelectAll
            ? (storeSearch?.search ?? [])
            : [],
        },
      },
    },
    selectRowKey: "StoreID",
  };

  return (
    <Sheet isPage className="order-tbl p-0">
      <SheetBody isTransparent className="p-0">
        <Stack isVertical gutter="small" className="generte-order-wrapper">
          <Stack className="generte-order-head p-0">
            <Title level={4}>{getColumnAliasName("Reserve Inventory")}</Title>
          </Stack>
          <StackItem isStretch isGrow onDomRef={handleUpdateRef}>
            <ThetaGridPaginated
              offset={60}
              parent={ref}
              config={templateConfig}
            />
          </StackItem>
          <StackItem>
            <Stack align="left" gutter="small">
              <StackItem isGrow>
                <Button isText name="Reselect SKUs" handleClick={goBack} />
              </StackItem>

              <StackItem isStretch align="right">
                <Button
                  disabled={
                    (isLoadingGrid && !hasGridData) || validateFormData()
                  }
                  isPrimary
                  name={getColumnAliasName("Review Orders")}
                  handleClick={handleNextClick}
                />
              </StackItem>
            </Stack>
          </StackItem>
        </Stack>
      </SheetBody>
    </Sheet>
  );
};

export default ReserveInventory;
